module.exports = __webpack_public_path__ + "static/media/carousel16.ac34a207.jpg";